import { render } from "./LinkSettings.vue?vue&type=template&id=7dc7b308&scoped=true"
import script from "./LinkSettings.vue?vue&type=script&lang=js"
export * from "./LinkSettings.vue?vue&type=script&lang=js"

import "./LinkSettings.vue?vue&type=style&index=0&id=7dc7b308&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc7b308"]])

export default __exports__